import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter, Input, ModalHeader } from 'reactstrap';
import React from 'react';
import DatePicker from 'react-datepicker';
import { t } from '../common/Translate';
import { useGuaranteedPrice } from '../../hooks/useGuaranteedPrice/useGuaranteedPrice';

export default function NCOrderLinkModel({ isOpen, toggle }) {
  const { recordId } = useParams();
  const today = new Date();
  const {
    setOfferId,
    setNewCarBrand,
    setNewCarModel,
    setExpectedDeliveryDate,
    offerId,
    isEnabled,
    newCarBrand,
    newCarModel,
    expectedDeliveryDate,
    handleConfirmNCOrder,
  } = useGuaranteedPrice(recordId);

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalBody className="update-date-modal">
        <ModalHeader>
          <p className="text">{t('linkNcOrderPopUpTittle')}</p>
        </ModalHeader>
        <Input
          isRequired
          className="form-control rounded icon-chevron-down"
          type="text"
          name="offerId"
          id="offerId"
          value={offerId}
          onChange={(e) => setOfferId(e.target.value)}
          placeholder={t('offerId')}
        />
        <Input
          className="form-control rounded icon-chevron-down"
          type="text"
          name="newCarBrand"
          id="newCarBrand"
          value={newCarBrand}
          onChange={(e) => setNewCarBrand(e.target.value)}
          placeholder={t('newCarBrand')}
        />
        <Input
          isRequired
          className="form-control rounded icon-chevron-down"
          type="text"
          name="newCarModel"
          id="newCarModel"
          value={newCarModel}
          onChange={(e) => setNewCarModel(e.target.value)}
          placeholder={t('newCarModel')}
        />
        <p className="text">{t('linkNcOrderPopUpsetEntryStockDate')}</p>
        <div className="form-group date-display">
          <p>{t('entryStockDate')}</p>
          <DatePicker
            className="form-control"
            name="meetingDate"
            id="meetingDate"
            onChange={setExpectedDeliveryDate}
            selected={expectedDeliveryDate}
            locale={t('language')}
            placeholderText={t('expectedDeliveryDate')}
            autoComplete="off"
            minDate={today}
          />
        </div>
      </ModalBody>
      <ModalFooter className="justify-content-center update-date-modal">
        <div className="model-footer">
          <button type="button" className="btn btn-3 mr-2" onClick={toggle}>
            {t('cancel')}
          </button>
          <button type="button" disabled={!isEnabled} className="btn btn-1" onClick={handleConfirmNCOrder}>
            {t('confirm')}
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
}
NCOrderLinkModel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};
